import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubscriptions } from "../../redux/actions/subscriptions.action";
import Channel from "./Channel";

import "./Subscriptions.css";

const Subscriptions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubscriptions());
  }, [dispatch]);

  const { loading, subscribedChannels } = useSelector(
    (state) => state.subscriptions
  );

  return (
    <div>
      {loading ? (
        <p>Loading subscriptions...</p>
      ) : (
        subscribedChannels.map((channel) => (
          <Channel channelId={channel.snippet.resourceId.channelId} />
        ))
      )}
    </div>
  );
};

export default Subscriptions;
